// @flow
/* eslint-disable */

import { throttle } from '../common/throttle';
import { memoize } from '../common/memoize';
import { loadScript } from '../common/load-script';
import { createScrollHandler } from '../common/create-scroll-handler';
import { isInViewport } from '../common/is-in-viewport';

import callRequestAds from './usat-wrapper-end';

function bootstrapGoogletag(cb) {
    const w = window;
    w.googletag = window.googletag || {};
    w.googletag.cmd = w.googletag.cmd || [];
    w.googletag.cmd.push(cb);
    return w.googletag;
}

function bootstrapPrebid(cb) {
    const w = window;
    w.pbjs = w.pbjs || {};
    w.pbjs.que = w.pbjs.que || [];
    w.googletag.cmd.push(() => { w.pbjs.que.push(cb); });
    return w.pbjs;
}

function bootstrapBlockthrough() {
    // Create a script element to load Blockthrough script 
    var btScript = document.createElement('script');
    // Update src based on link given to you by your PS manager
    btScript.src = '//btloader.com/tag?o=5067096939560960&upapi=true';
    // Insert script in the head
    var container = document.head || document.body;
    if (container) {
        container.appendChild(btScript);
    }
}
bootstrapBlockthrough();

const requestAdsOnce = memoize(callRequestAds);
const REFRESH_INTERVAL = 30 * 1000;

export class CoreService {
    queue: any[] = [];

    scrollHandler: any;

    gtag: any;

    pbjs: any;

    _dependecies: Promise<any>;

    _refreshInterval: any;

    _isRefresh: boolean = false;

    _location: string = '';

    static getInstance(): CoreService {
        window.__ark_ads__ = window.__ark_ads__ || {};
        window.__ark_ads__.coreServiceInstance = window.__ark_ads__.coreServiceInstance || new CoreService();
        window.__ark_ads__.displayAd = window.__ark_ads__.displayAd || {};
        return window.__ark_ads__.coreServiceInstance;
    }

    constructor() {
        this._dependecies = Promise.all([
            // Arkadium's Fill Blank Ads
            loadScript('https://ams.cdn.arkadiumhosted.com/assets/display/adlib/blank.js'),
            // USAT Prebid.js
            loadScript('https://www.gannett-cdn.com/partner/vendor/pbjsandwich.min.js'),
            // USAT GPT
            loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js'),
            // USAT Amazon
            loadScript("https://c.amazon-adsystem.com/aax2/apstag.js")
        ]);

        this.gtag = bootstrapGoogletag(() => {
            window.googletag.pubads().disableInitialLoad();
            window.googletag.pubads().addEventListener('slotOnload', (event) => {
                const slotId = event.slot.getSlotElementId();
                this.onShowGTMEvent([slotId], this._isRefresh);
            });
        });
        this.pbjs = bootstrapPrebid(() => {});
        this._refreshInterval = setInterval(this.refreshAds, REFRESH_INTERVAL);
        this._location = window.location.pathname;
    }

    getComponentBySlotId(id: string) {
        const slot = document.querySelector(`#${id}`);
        if (slot) {
            return slot.parentElement;
        }
        return null;
    }

    queueAdShow(elem: any) {
        this.queue.push(elem);
        this.processQueue();
    }

    removeAd(el: any) {
        this.queue = this.queue.filter(qEl => qEl === el);
        this.gtag.cmd.push(() => {
            this.gtag.destroySlots([ el ]);
        });
    }

    onShowGTMEvent(els: string[], isRefresh?: boolean) {
        return { els, isRefresh };
    }

    refreshAds = () => {
        this._isRefresh = true;
        window.requestAds();
    }

    processQueue = throttle(() => {
        if (this._location !== window.location.pathname) {
            this.gtag.destroySlots();
            this.gtag.pubads().updateCorrelator();
            this._location = window.location.pathname;
        }
        this.pbjs.que.push(() => {
            window.dataToSend = [];
            const toRender = this.queue;
            toRender.forEach(el => el.render());
            callRequestAds();
        });
    });
}
